/**
 * Expose changes on components
 */

export class UIConfigBroadcastModel {
	component: UIConfigComponent;
	styles: any;

	constructor() {
		this.styles = null;
	}

}

export enum UIConfigComponent {
	LOGO = 'logo',
	TITLE = 'title',
	FAVICON = 'favIcon',
	HEADER = 'header',
	LEFT_MENU = 'leftMenu',
	FOOTER = 'footer',
	ORDER_VIEW = 'orderView'
}

// List of Elements that apply to all apps
export const MAIN_APP_CONFIG_CHANGE = [
	UIConfigComponent.TITLE,
	UIConfigComponent.FAVICON,
	UIConfigComponent.HEADER,
	UIConfigComponent.FOOTER,
	UIConfigComponent.LEFT_MENU
];
